import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import ActivationModal from '../Auth/ActivationModal';
import ActivationResultModal from '../Auth/ActivationResultModal';
import ForgotPasswordModal from '../Auth/ForgotPasswordModal';
import LoginModal from '../Auth/LoginModal';
import RegistrationModal from '../Auth/RegistrationModal';

const Modals = () => {
	const {
		isLoginModalOpen,
		isRegisterModalOpen,
		isActivationModalOpen,
		isActivationResultModalOpen,
		isSetForgotPasswordModalOpen,
	} = useSelector((state: RootState) => state.ui.modals);

	return (
		<>
			{isLoginModalOpen && <LoginModal />}
			{isRegisterModalOpen && <RegistrationModal />}
			{isActivationModalOpen && <ActivationModal />}
			{isActivationResultModalOpen && <ActivationResultModal />}
			{isSetForgotPasswordModalOpen && <ForgotPasswordModal />}
		</>
	);
};

export default Modals;
